import URLConfig from '@Config/urls/url.config';
import { LinkItemProps } from '@Layouts/sidebar/AppSidebar';

const URL = URLConfig.TERMINAL_MANAGEMENT_SYSTEM.GAB_MANAGEMENT.BANK_MENU;

const BankMenuLink: Array<LinkItemProps> = [
  {
    name: 'Configuration FDK',
    link: URL.FDK_CONFIGURATION,
    level: 3,
  },
  {
    name: 'Configuration',
    link: URL.CONFIGURATION,
    level: 3,
  },
  
];

export default BankMenuLink;
